import { useState } from "react";
import Button from "../../../../components/Button";
import ButtonIcon from "../../../../components/ButtonIcon";
import { lang } from "../../../../functions/lang";
import ModalTitleText from "../../../usuario/components/ModalTitleText";
import RangeMoney from "../RangeMoney";
import styles from "./styles.module.css";

import { getUrls } from "../../../../services/wl/getUrls";
import IconBusiness from "../../../../components/Icon/IconBusiness";
import IconUser from "../../../../components/Icon/IconUser";
import Select2 from "../../../../components/Select/Select2";
import { handleFindOptionsMunicipios } from "../../../../functions/find-municipios";
import { configSimulacao } from "./configSimulacao";
import { findPlanosDescontos } from "./findPlanosDescontos";
import { getResultFailMessage } from "./getResultMessages";
import { getResultDiscountMessage } from "./getResultMessages";
import Router from "next/router";
import { getLead, saveLead } from "../../../../functions/leads";
import { COOKIES_TAGS } from "../../../../functions/cookies/COOKIES_TAGS";
import { deleteCookie } from "cookies-next";

/**
 * Formulário da Calculadora
 *
 * - Campos adicionais poderão ser adicionados com prefixo "ef_": Extra Field.
 * Ex: `https://app.electy.com.br/calculadora-desconto?type=form&ef_campo1=123&ef_campo2=456`
 *
 * No exemplo temos os campos ef_campo1 e ef_campo2 adicionados e incorporados dinamicamente
 */
const FormNovaJornada = (props) => {
  // Valida se deve aparecer opções para selecionar "PF"|"PJ"
  const oneOptionContractEnabled =
    props.wl.Calculadora.habilitar_contrato_pf &&
    !props.wl.Calculadora.habilitar_contrato_pj
      ? "pf"
      : props.wl.Calculadora.habilitar_contrato_pj &&
        !props.wl.Calculadora.habilitar_contrato_pf
      ? "pj"
      : false;

  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    valorConsumo: 150,
    dataDiscount: "",
    dataConfigOfertas: null,
    selectedConcessionaria: null,
    submitButtonChildren: "QUERO SABER MAIS",
    errorMessage: "",
    concessionariasMunicipio: [],
    selectedTypeButton: {
      selected: oneOptionContractEnabled ? oneOptionContractEnabled : "", // Verifica se é apenas um tipo de seleção: ou só PF ou só PJ (ou '' para ambos)
      pf: "",
      pj: "",
    },
  });
  

  const handleSelectTipoPessoa = (type) => {
    setFormData({
      ...formData,
      selectedTypeButton: {
        pf: type == "pf" ? "selected" : "",
        pj: type == "pj" ? "selected" : "",
        selected: type,
      },
    });
    setErrorMessage("");
  };

  const [selectedConcessionaria, setSelectedConcessionaria] = useState(null);
  // const enableSharp = props.infos.usa_sharpspring;
  const [submitButtonChildren, setSubmitButtonChildren] =
    useState("QUERO SABER MAIS");

  const [errorMessage, setErrorMessage] = useState("");
  const [concessionariasMunicipio, setConcessionariasMunicipio] = useState([]);

  // Cada campo não preenchido é recebido nessa função: Se algum estiver na lista de bloqueados, a chamada é interrompida
  const hasInvalidInputs = (e) => {
    if (e.target.getAttribute("name") == "tipoConta") {
      setErrorMessage("Selecione o tipo da conta!");
      return true;
    }
    if (e.target.getAttribute("name") == "concessionaria") {
      setErrorMessage("Selecione a concessionária!");
      return true;
    }

    return false;
  };

  const imgSplash = getUrls(props.wl?.splash?.data?.attributes?.url);

  const onSubmit = async (e) => {
    e.preventDefault();

    const formData = {};
    const formElements = e.target.elements;

    for (let element of formElements) {
      if (element.name) {
        formData[element.name] = element.value;
      }
    }

    let savedLead = {};
    try {
      const municipioEstado = formData.municipio?.split(" - ");
      const municipio = municipioEstado?.[0];
      const uf = municipioEstado?.[1];
      
      deleteCookie(COOKIES_TAGS.LEAD_ID);
      
      savedLead = await saveLead({
        assessor: formData.ef_assessor || formData.ef_parceiro,
        campanha: formData.representante,
        municipio: municipio,
        uf: uf,
        concessionaria: Number(formData.concessionaria),
        tipo: formData.tipoConta,
        valor_consumo: formData.money,
      });
    } catch (error) {
      console.log({ error });
    }

    setIsLoading(true);

    setTimeout(() => {
      setIsLoading(false);
    }, 10000);

    Router.push(`/form-dados-pessoais`);
    return;
  };

  const bgSubmitButton =
    submitButtonChildren != "QUERO SABER MAIS" || !formData?.dataDiscount.status
      ? { background: "transparent" }
      : {
          color: props.wl?.cor_texto_botao,
          background: props.wl?.cor_tema_botao_solido
            ? props.wl?.cor_tema_botao_solido
            : "1",
        };

  /**
   * Configura a option de concessionária para o Lead
   */
  const handleMunicipioChange = (_selectedMunicipio) => {
    const concessionariaOptions = [];
    _selectedMunicipio?.concessionarias?.map((concessionaria) => {
      concessionariaOptions.push({
        id: concessionaria.id,
        name: concessionaria.attributes.nome,
        label: concessionaria.attributes.nome,
        value: concessionaria.id,
      });
    });

    setConcessionariasMunicipio(concessionariaOptions);

    if (concessionariaOptions.length < 2) {
      setSelectedConcessionaria(concessionariaOptions?.[0]);
      findPlanosDescontos({
        concessionariaId: concessionariaOptions?.[0]?.id,
      }).then((_dataConfigOfertas) => {
        setFormData({
          ...formData,
          dataConfigOfertas: _dataConfigOfertas,
        });

        configSimulacao({
          setFormData,
          formData: { ...formData, dataConfigOfertas: _dataConfigOfertas },
          concessionariaId: concessionariaOptions?.[0]?.id,
        });
      });
    }
  };

  const handleConcessionariaChange = (_selectedConcessionaria) => {
    console.log({ _selectedConcessionaria });
    setSelectedConcessionaria(_selectedConcessionaria);

    findPlanosDescontos({ concessionariaId: _selectedConcessionaria.id }).then(
      (_dataConfigOfertas) => {
        setFormData({
          ...formData,
          dataConfigOfertas: _dataConfigOfertas,
        });

        configSimulacao({
          setFormData,
          formData: { ...formData, dataConfigOfertas: _dataConfigOfertas },
          concessionariaId: _selectedConcessionaria.id,
        });
      }
    );
  };

  if (isLoading) {
    return (
      <>
        <img
          className={styles.iconLoading}
          src={imgSplash}
          width={150}
          height={150}
        />
      </>
    );
  }

  const formProps = props.isApp
    ? {
        onSubmit: onSubmit,
        className: styles.form,
        onInvalid: hasInvalidInputs,
        method: "get",
      }
    : {
        className: styles.form,
        onInvalid: hasInvalidInputs,
        action: `${process.env.NEXT_PUBLIC_BASE_URL}/form-dados-pessoais`,
        target: "_blank",
        method: "get",
      };

  return (
    <>
      <form {...formProps}>
        {props.extraFields.map((item) => (
          <input
            type="hidden"
            key={`INPUT__${item.key}`}
            name={item.key?.toLowerCase() ?? item.key}
            value={item.value}
          />
        ))}
        <input
          type="hidden"
          name="representante"
          value={props.owner ?? props.wl.campanha_default}
        />
        <input type="hidden" name="full" value={props.full ? "1" : ""} />
        <h3 className={`mobile__h3 ${styles.title}`}>Calcule sua economia</h3>
        {/* SELECT DE MUNICIPIOS */}
        <Select2
          id="select"
          name="municipio"
          required
          handleChange={handleMunicipioChange}
          placeholder="Cidades"
          handleFindOptions={handleFindOptionsMunicipios}
        />
        {concessionariasMunicipio.length > 1 ? (
          //Select de Concessionarias
          <Select2
            id="concessionaria"
            isSearchable={false}
            name="concessionaria"
            required
            placeholder="Selecione a Concessionária"
            handleChange={handleConcessionariaChange}
            options={concessionariasMunicipio}
          />
        ) : (
          <>
            <input
              type="hidden"
              name="concessionaria"
              value={concessionariasMunicipio?.[0]?.id}
            />
            <input
              type="hidden"
              name="concessionaria_sigagente"
              value={concessionariasMunicipio?.[0]?.sigagente}
            />
          </>
        )}
        {!oneOptionContractEnabled && (
          <>
            <h5 className={`mobile__h5 ${styles["title-select-type"]}`}>
              Escolha uma opção:
            </h5>
            <article className={styles["select-type"]}>
              <ButtonIcon
                color={props.wl.Calculadora.cor_botao_select}
                hoverColor={props.wl.Calculadora.cor_hover_botao_icon}
                type={"button"}
                // bgOnMouseLeave={"#fff"}
                data-attr="pf"
                onClick={() => {
                  handleSelectTipoPessoa("pf");
                  configSimulacao({
                    setFormData,
                    formData: {
                      ...formData,
                      selectedTypeButton: {
                        pf: "selected",
                        pj: "",
                        selected: "pf",
                      },
                    },
                    concessionariaId: selectedConcessionaria?.id,
                  });
                }}
                className={`${styles.button} ${formData?.selectedTypeButton?.pf}`}
                wl={props.wl}
                // srcIcon="/images/busca-usinas/step-0/user.svg"
                svgTag={
                  <IconUser
                    color={props.wl.Calculadora.cor_botao_select}
                    wl={props.wl}
                  />
                }
              >
                Para sua casa
              </ButtonIcon>         

              <ButtonIcon
                color={props.wl.Calculadora.cor_botao_select}
                hoverColor={props.wl.Calculadora.cor_hover_botao_icon}
                type={"button"}
                data-attr="pj"
                // bgOnMouseLeave={"#fff"}
                onClick={() => {
                  handleSelectTipoPessoa("pj");
                  configSimulacao({
                    setFormData,
                    formData: {
                      ...formData,
                      selectedTypeButton: {
                        pf: "",
                        pj: "selected",
                        selected: "pj",
                      },
                    },
                    concessionariaId: selectedConcessionaria?.id,
                  });
                }}
                className={`${styles.button} ${formData?.selectedTypeButton?.pj}`}
                // srcIcon="/images/busca-usinas/step-0/bag.svg"
                wl={props.wl}
                svgTag={
                  <IconBusiness
                    color={props.wl.Calculadora.cor_botao_select}
                    wl={props.wl}
                  />
                }
              >
                Para seu negócio
              </ButtonIcon>
            </article>
          </>
        )}
        {errorMessage ? (
          <div className={`msg__error__icon__alert ${styles["msg-error"]}`}>
            <img src="/images/icons/notifications/alert-cicle.svg"></img>
            <span className="error">{errorMessage}</span>
          </div>
        ) : (
          ""
        )}

        <input
          type={"text"}
          id="tipoConta"
          name="tipoConta"
          defaultValue={formData?.selectedTypeButton?.selected ?? ""}
          required
          style={{ display: "none" }}
        />
        <input
          type="hidden"
          name="pessoaFisica"
          defaultValue={
            formData?.selectedTypeButton?.selected === "pf" ? "Sim" : "Não"
          }
        />
        <input
          type="hidden"
          name="pessoaJuridica"
          defaultValue={
            formData?.selectedTypeButton?.selected === "pj" ? "Sim" : "Não"
          }
        />

        <article>
          <h5 className={`mobile__h5 ${styles.h5}`}>
            {props.wl.Calculadora.texto_descricao_consumo ??
              "Quanto você gasta com luz por mês?"}
          </h5>
          <p className={`mobile__p5 ${styles.p5}`}>
            Arraste até atingir o valor da sua conta de luz ou digite o valor
            abaixo
          </p>
        </article>
        <RangeMoney
          name="money"
          wl={props.wl}
          defaultValue={formData.valorConsumo}
          max={50000}
          handleUpdateValue={(newValue) => {
            setFormData({
              ...formData,
              valorConsumo: newValue,
            });
            configSimulacao({
              setFormData,
              formData: { ...formData, valorConsumo: newValue },
              concessionariaId: selectedConcessionaria?.id,
            });
          }}
        />
        {
          <p className="economiainfo">
            {!formData?.dataDiscount?.status
              ? getResultFailMessage(formData?.dataDiscount?.message)
              : getResultDiscountMessage(
                  formData?.dataDiscount?.valorDescontoAnual,
                  props?.wl?.cor_tema_primaria
                )}
          </p>
        }
        <Button
          name={submitButtonChildren}
          isDisable={
            submitButtonChildren != "QUERO SABER MAIS" ||
            !formData?.dataDiscount?.status
          }
          type="submit"
          style={bgSubmitButton}
          wl={props.wl}
        />

        {
          props.isApp ?       
            <div className={styles["text-privacy-policy"]}>
              <>
                <span>Ao prosseguir significa que você aceita nossos</span>
                <span>
                  <a>
                    <ModalTitleText
                      src-icon-close={"/images/icons/button/close-white.svg"}
                      content={lang("usuario/index.termos-uso", "")}
                    />
                  </a>{" "}
                  e
                  <a>
                    <ModalTitleText
                      src-icon-close={"/images/icons/button/close-white.svg"}
                      content={lang("usuario/index.politica-privacidade", "")}
                    />
                  </a>
                </span>
              </>
            </div>
          : 
            <div className={styles["text-privacy-policy"]}>
              <>
                <span>Ao prosseguir significa que você aceita os </span>
                <br></br>
                <span>
                  <a>
                    <ModalTitleText
                      src-icon-close={"/images/icons/button/close-white.svg"}
                      content={lang("usuario/index.termos-uso", "")}
                    />
                  </a>
                  e
                  <a>
                    <ModalTitleText
                      src-icon-close={"/images/icons/button/close-white.svg"}
                      content={lang("usuario/index.politica-privacidade", "")}
                    />
                  </a>
                </span>
                <br></br>
                <span>da Electy</span>

              </>
            </div>
        }
      </form>
    </>
  );
};

export default FormNovaJornada;
